"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feedback = void 0;
/**
 * FeedbackDto represents the request body to create a new feedback
 * @property {string}    id               - feedback unique identifier
 * @property {string}    feedback         - represents the message to store as a feedback
 * @property {string}    itemExternalId   - represents the item external id to assign that message
 * @property {string}    createdBy        - person who provided the feedback
 *
 */
var Feedback = /** @class */ (function () {
    function Feedback(feedback) {
        if (feedback === void 0) { feedback = {}; }
        Object.assign(this, feedback);
    }
    return Feedback;
}());
exports.Feedback = Feedback;
